/**
 * Delete prompt controller - handles delete business logic
 */

import * as promptLibraryService from '../../data/services/promptLibraryService';

/**
 * Delete a prompt (only if user is the creator)
 * @param {string} promptId - The prompt ID
 * @param {string} userId - The user ID
 * @returns {Promise<Object>} Result with success status
 */
export const deletePrompt = async (promptId, userId) => {
  try {
    const result = await promptLibraryService.deletePrompt(promptId, userId);
    return result;
  } catch (error) {
    console.error('Error deleting prompt:', error);
    return { success: false, error: error.message };
  }
};

